import React, { useCallback, useState } from 'react'
// import { Grid, Tooltip, Typography } from '@material-ui/core'
import Button from '_components/button'
import { RotateRight } from '@refera/ui-icons'

import { useStyles } from './styles'
import { useDispatch } from 'react-redux'
import { fetchMoreKanbanColumn } from '_/modules/service-orders/actions'
import humps from 'humps'
import { useUrlParams } from '_/hooks/use-url-params'
import { useToast } from '_/hooks/use-toast'
import { CircularProgress } from '@material-ui/core'

export function ColumnFooter({ column, minimizedColumns }) {
  const styles = useStyles()
  const dispatch = useDispatch()
  const { getAllParams } = useUrlParams()
  const { showToast } = useToast()
  const [loading, setLoading] = useState(false)
  const isMinimized = minimizedColumns.has(column.id)

  const handleButtonClick = async () => {
    const filters = getAllParams()

    try {
      setLoading(true)
      await dispatch(
        fetchMoreKanbanColumn({
          ...filters,
          columnName: humps.decamelize(column.id),
          offset: column.nextOffset,
        })
      )
    } catch (error) {
      showToast({ type: 'error' })
    } finally {
      setLoading(false)
    }
  }

  const renderContent = useCallback(() => {
    if (loading) return <CircularProgress size={20} className={styles.loader} />
    return (
      <>
        <RotateRight className={styles.buttonIcon} />
        Carregar mais
      </>
    )
  }, [loading])

  if (!column?.nextOffset || isMinimized) return null

  return (
    <div className={styles.footer}>
      <Button className={styles.button} onClick={handleButtonClick} disabled={loading}>
        {renderContent()}
      </Button>
    </div>
  )
}
